'use strict';

import instance from '~api/_instance';

function id(carId, modelCode, coordinate) {
    return instance({
        method: 'get',
        url: '/api/shop/recommend/consignment/car/id',
        params: {
            carId, modelCode, coordinate
        }
    });
}

export {
    id
};



// WEBPACK FOOTER //
// ./src/api/shop/recommend/consignment/car.js